import { URIFormat } from './enums/uri_format';
import { URITypeMap } from './enums/uri_type';
import { base62FromHex, base62ToHex } from './base62';
import { parseURI } from './uri';
import { parseFromComponents } from './_internal/parser';
import { decodeComponent, encodeComponent } from './_internal/helpers';
/*
 * Checks whether two URI:s refer to the same thing even though they might
 * not necessarily be equal.
 *
 * These two Playlist URIs, for example, refer to the same playlist:
 *
 * spotify:user:napstersean:playlist:3vxotOnOGDlZXyzJPLFnm2
 * spotify:playlist:3vxotOnOGDlZXyzJPLFnm2
 */
export function isSameIdentity(a, b) {
    const uriA = parseURI(a);
    const uriB = parseURI(b);
    if (!uriA || !uriB)
        return false;
    if (uriA.toString() === uriB.toString())
        return true;
    if ((uriA.type === URITypeMap.PLAYLIST ||
        uriA.type === URITypeMap.PLAYLIST_V2) &&
        (uriB.type === URITypeMap.PLAYLIST || uriB.type === URITypeMap.PLAYLIST_V2)) {
        return uriA.id === uriB.id;
    }
    if (uriA.type === URITypeMap.STATION && uriB.type === URITypeMap.STATION) {
        const stationContextUriA = parseFromComponents(uriA.args, URIFormat.URI);
        return (!!stationContextUriA &&
            isSameIdentity(stationContextUriA, parseFromComponents(uriB.args, URIFormat.URI)));
    }
    return false;
}
/**
 * Returns the hex representation of a Base62 encoded id.
 *
 * @param id - The base62 encoded id.
 * @returns The hex representation of the base62 id.
 */
export function idToHex(id) {
    if (id.length === 22) {
        return base62ToHex(id);
    }
    return id;
}
/**
 * Returns the base62 representation of a hex encoded id.
 *
 * @param hex - The hex encoded id.
 * @returns The base62 representation of the id.
 */
export function hexToId(hex) {
    if (hex.length === 32) {
        return base62FromHex(hex);
    }
    return hex;
}
/**
 * Returns the canonical representation of a username.
 *
 * @param username - The username to encode.
 * @returns The encoded canonical representation of the username.
 */
export function getCanonicalUsername(username) {
    return encodeComponent(username, URIFormat.URI);
}
/**
 * Returns the non-canonical representation of a username.
 *
 * @param username - The username to encode.
 * @returns The unencoded canonical representation of the username.
 */
export function getDisplayUsername(username) {
    return decodeComponent(username, URIFormat.URI);
}
//# sourceMappingURL=utils.js.map